import { GET, PATCH } from './Httpr.js';
const prefix = 'notifications/'

export async function getAllUnreadNotifications(){
    let url = 'unread';

    let rsp = await GET(prefix + url, {});

    return rsp;
}

export async function getNotifications(page = 1){
    let url = 'getAll';
    let requestData = {
        page: page
    }

    let rsp = await GET(prefix + url, requestData);

    return rsp;
}

export async function setAsRead(id){
    let url = 'setAsRead';
    let requestData = {
        notification_id: id
    }

    let rsp = await PATCH(prefix + url, requestData);

    return rsp;
}

export async function getById(id){
    let url = 'getById';
    let requestData = {
        id: id
    }

    let rsp = await GET(prefix + url, requestData);

    return rsp;
}